import {
  UpgradeUserPlanInterface,
  UpgradeUserPlanResponseInterface,
} from 'modules/profile/user-plan/types/user-plan-interface'
import httpClient from 'shared/utils/http-client'

export const USER_PLAN_API = '/api/dashboard/customer/settings/user-plan'
export const USER_PLAN_V2_API = `${USER_PLAN_API}/v2`

export const updateUserPlan = (data: UpgradeUserPlanInterface) =>
  httpClient.post<UpgradeUserPlanResponseInterface>(`${USER_PLAN_API}/upgrade`, data)

/**
 * The SWR key for the main user-plan/v2 fetch. Anything that wants to read the
 * page's plan data (and have `mutate()` refresh it) should key off this
 * directly. A poll that shouldn't share cache identity with the main page
 * data (see useUserPlanUpgradePolling) should extend this tuple with an extra
 * tag instead of reusing it verbatim, so its periodic refetches don't
 * silently update — and re-render — every other consumer of this key.
 */
export const getUserPlanKey = (locale: string) => [USER_PLAN_V2_API, locale] as const
